<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Register Calibration Certificate Note</h5>
    <form [formGroup]="AddNewCertificateNote" (submit)="SubmitAddNewCertificateNote()">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Code</label>
          <input formControlName="Code" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Code().valid && get_Form_Code().touched"
            class="form-text text-muted MyErrorRedColor">Please enter a code.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Text</label>
          <input formControlName="Dsc" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched"
            class="form-text text-muted MyErrorRedColor">Please enter the note text.</small>
        </div>
      </div>
      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewCertificateNote.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Information </button>
      <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i
          class="fa fa-times-rectangle"></i> Cancel </button>
      <button routerLink="/CertificateNote" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> Back </button>
    </form>
  </div>
</div>
